import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";
import { PaginatedSearch } from "@/types";
import { QualifierUser } from "../user";

export type Project = {
  id: string;
  number?: string;
  name: string;
  description?: string;
  status?: number;
  createdById?: string;
  creationDate?: Date;
  lastUsedDate?: Date;
  addedFrom?: string;
};

export type ProjectListView = {
  id: string;
  number?: string;
  name: string;
  description?: string;
  status?: string;
  pinned: boolean;
};

export interface ProjectFilters extends PaginatedSearch {
  favorite: boolean;
  owned: boolean;
  tier2: boolean;
  incomplete: boolean;
  welderId: string;
  searchString: string;
}

export type ProjectValidation = {
  isProjectUnique: boolean;
};

export type ProjectAssociations = {
  owners: QualifierUser[];
  inspectors: QualifierUser[];
  specialists: QualifierUser[];
  favorited: QualifierUser[];
};

export type ProjectMetrics = {
  weldersTested: number;
  welderTests: number;
  api1104Tests: number;
  asmeTests: number;
  inServiceTests: number;
  testsPassed: number;
  testsFailed: number;
  passRate: number;
};

export function getProjectList(filters: Partial<ProjectFilters>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<ProjectListView[]>(`williams/projects?${params}`);
}

export function getProjectLookup(search: string) {
  return api.get<Project[]>(`williams/projects/lookup?search=${search}`);
}

export function getProjectById(id: string) {
  return api.get<Project>(`williams/projects/${id}`);
}

export function saveProject(project: Project) {
  return api.post<Project>("williams/projects", project);
}

export function validateProject(project: Project) {
  return api.post<ProjectValidation>("williams/projects/validate", project);
}

export function togglePinned(id: string) {
  return api.post(`williams/projects/pin?id=${id}`);
}

export function deleteProject(id: string) {
  return api.delete(`williams/projects/${id}`);
}

export function findSimilarProjects(project: Project) {
  return api.post<Project[]>("williams/projects/similar", project);
}

export function getProjectAssociations(id: string) {
  return api.get<ProjectAssociations>(`williams/projects/${id}/associations`);
}

export function getProjectMetrics(id: string) {
  return api.get<ProjectMetrics>(`williams/projects/${id}/metrics`);
}
